import React, {useState} from 'react';
import {baseUrl} from "../../../../constants/constants";
import {FaTelegramPlane, FaVk} from "react-icons/fa";
import {INewsPublic} from "../news";
import {toast} from "react-toastify";
import isActive = toast.isActive;

const OneNews = ({id, name, description, image_url, source_link, dzen_link, tg_link, tags, create_date}: INewsPublic) => {
    const [activeLink, setActiveLink] = useState(false);
    const [isPressed, setIsPressed] = useState(false)

    const createDateNews = new Date(create_date).toLocaleString('ru', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });

    const handleClick = () => {
        window.open(dzen_link, '_blank');
    };

    return (
        <div>
            <section className="news-card">
                <section className={'news_text'}>
                    <div className="news-desc">
                        <h3 className='news-title'>{name}</h3>
                        <p className='news-p'>{description}</p>
                    </div>
                    <section className={'news_read'}>
                        <div className={'news_read_buttons'}>
                            <button
                                className={`news_read_buttons_button ${activeLink ? 'active' : ''} ${isPressed ? 'pressed' : ""}`}
                                onClick={() => setActiveLink(!activeLink)}
                                onTouchStart={() => setIsPressed(true)}
                                onTouchEnd={() => setIsPressed(false)}
                            >
                                Подробнее {'>'}
                            </button>
                            <div
                                className={`news_read_buttons_links ${activeLink ? 'show' : ''}`}
                            >
                                <a href={`${source_link}`} target={"_blank"} rel="noreferrer">
                                    <FaVk className={'news_read_buttons_links_icon'}/>
                                </a>
                                <a href={`${tg_link}`} target={"_blank"} rel="noreferrer">
                                    <FaTelegramPlane className={'news_read_buttons_links_icon'}/>
                                </a>
                                <a onClick={handleClick} target={"_blank"} style={{cursor:'pointer', marginLeft:'5px'}} rel="noreferrer">

                                    <svg width="23" height="28" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg"
                                         className={'social-icon_dzen'}
                                    >
                                        <path
                                            d="M14.3143 14.3143C12.4286 16.26 12.2914 18.6857 12.1286 24C17.0829 24 20.5029 23.9829 22.2686 22.2686C23.9829 20.5029 24 16.92 24 12.1286C18.6857 12.3 16.26 12.4286 14.3143 14.3143ZM0 12.1286C0 16.92 0.0171428 20.5029 1.73143 22.2686C3.49714 23.9829 6.91714 24 11.8714 24C11.7 18.6857 11.5714 16.26 9.68571 14.3143C7.74 12.4286 5.31429 12.2914 0 12.1286ZM11.8714 0C6.92571 0 3.49714 0.0171428 1.73143 1.73143C0.0171428 3.49714 0 7.08 0 11.8714C5.31429 11.7 7.74 11.5714 9.68571 9.68571C11.5714 7.74 11.7086 5.31429 11.8714 0ZM14.3143 9.68571C12.4286 7.74 12.2914 5.31429 12.1286 0C17.0829 0 20.5029 0.0171428 22.2686 1.73143C23.9829 3.49714 24 7.08 24 11.8714C18.6857 11.7 16.26 11.5714 14.3143 9.68571Z"
                                        />
                                    </svg>

                                </a>
                            </div>
                        </div>
                        <div className={`news_read_date ${activeLink ? 'shifted' : ''}`}>
                            <p className={'news_read_date_btn'}>{createDateNews}</p>
                        </div>
                    </section>
                </section>
                <img
                    className='news-img'
                    src={`${baseUrl}${image_url}`}
                    alt="Картинка новости"/>
            </section>
        </div>
    );
};

export default OneNews;

// import React from 'react';
// import {INewsPublic} from "../news";
// import {baseUrl} from "../../../../constants/constants";
//
// const OneNews = ({id, name, description, image_url, source_link, create_date}: INewsPublic) => {
//     return (
//         <div>
//             <section className="news-card">
//                 <div className="news-desc">
//                     <a
//                         href={source_link}
//                         className='news-source_link'
//                         target='_blank'
//                     >
//                         <h3 className='news-title'>{name}</h3>
//                     </a>
//                     <p className='news-p'>{description}</p>
//                 </div>
//                 <img
//                     className='news-img'
//                     src={`${baseUrl}${image_url}`}
//                     alt="Картинка новости"/>
//             </section>
//         </div>
//     );
// };
//
// export default OneNews;